import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShieldFailIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.32252 1.33337C9.07785 1.33337 13.0419 2.69404 13.5659 3.21871C14.0032 3.65604 13.9965 4.00937 13.9659 5.70471C13.9539 6.38337 13.9372 7.30804 13.9372 8.58604C13.9372 13.174 8.69052 14.8154 8.46718 14.8827C8.41985 14.8974 8.37118 14.904 8.32252 14.904C8.27385 14.904 8.22518 14.8974 8.17785 14.8827C7.95452 14.8154 2.70785 13.174 2.70785 8.58604C2.70785 7.30604 2.69118 6.38137 2.67918 5.70271C2.67371 5.40033 2.669 5.14068 2.66744 4.91564L2.66724 4.66171C2.67289 3.82746 2.75102 3.54671 3.07852 3.21871C3.60318 2.69404 7.56718 1.33337 8.32252 1.33337ZM8.32252 2.33337C7.75718 2.33337 4.18985 3.58937 3.77852 3.93271C3.69962 4.01204 3.67031 4.13014 3.66656 4.59876L3.66626 4.77922C3.66705 5.00792 3.6717 5.30227 3.67852 5.68404C3.69118 6.36804 3.70785 7.29804 3.70785 8.58604C3.70785 12.0534 7.52252 13.5927 8.32185 13.876C9.12052 13.5914 12.9372 12.0434 12.9372 8.58604C12.9372 7.29937 12.9539 6.37004 12.9659 5.68604C12.9729 5.30391 12.9776 5.0093 12.9784 4.78026L12.978 4.59949C12.9738 4.12992 12.9426 4.01017 12.8585 3.92604C12.4545 3.58937 8.88785 2.33337 8.32252 2.33337ZM7.42312 6.35817L8.32257 7.25804L9.22192 6.35817C9.41725 6.16284 9.73325 6.16284 9.92858 6.35817C10.1239 6.55351 10.1239 6.86951 9.92858 7.06484L9.02924 7.96471L9.92845 8.86351C10.1238 9.05884 10.1238 9.37484 9.92845 9.57017C9.83112 9.66817 9.70312 9.71684 9.57512 9.71684C9.44712 9.71684 9.31912 9.66817 9.22178 9.57017L8.32257 8.67137L7.42325 9.57017C7.32592 9.66817 7.19792 9.71684 7.06992 9.71684C6.94192 9.71684 6.81392 9.66817 6.71658 9.57017C6.52125 9.37484 6.52125 9.05884 6.71658 8.86351L7.6159 7.96471L6.71645 7.06484C6.52112 6.86951 6.52112 6.55351 6.71645 6.35817C6.91178 6.16284 7.22778 6.16284 7.42312 6.35817Z",
      fill: __props.color || '#5528B5'
    }, null, 8, _hoisted_2)
  ]))
}
}

})